/**
 * Outbox offline types — FWA-PWA-029 (reemplaza scaffold PWA-021).
 *
 * PII tier Crítico: payloads pueden contener datos de menores. Retention strict
 * per privacy.md §6: success → delete inmediato, 401 → clearAll, logout → clearAll.
 */

export type OutboxStatus = 'pending' | 'syncing' | 'success' | 'failed';

export type OutboxMethod = 'POST' | 'PATCH' | 'DELETE';

export interface OutboxRecord {
  id: string;
  endpoint: string;
  method: OutboxMethod;
  payload: unknown;
  headers: Record<string, string>;
  status: OutboxStatus;
  attempts: number;
  last_error: string | null;
  created_at: string;
  updated_at: string;
  next_retry_at: string | null;
  conflict: boolean;
}

export const MAX_ATTEMPTS = 5;

/**
 * Backoff schedule en ms desde el último intento.
 * Cuando attempts >= MAX_ATTEMPTS → status='failed' (terminal).
 */
export const BACKOFF_SCHEDULE_MS: readonly number[] = [
  1_000, 5_000, 30_000, 120_000, 600_000,
] as const;

export function computeBackoffMs(attempts: number): number {
  const idx = Math.min(attempts, BACKOFF_SCHEDULE_MS.length - 1);
  return BACKOFF_SCHEDULE_MS[idx] ?? 600_000;
}
